// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Recommended Portfolio",
    titleHelp: "Optional heading to display above the portfolio table",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    showIsin: "Show ISIN",
    showIsinHelp: "Display ISIN code for each product",
    showWeights: "Show Product Weights",
    showWeightsHelp: "Display percentage allocation for each product",
    showAmount: "Show Amount",
    showAmountHelp: "Display investment amount for each product",
    showUnits: "Show Units",
    showUnitsHelp: "Display number of units for units-ordered products",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Anbefalt portefølje",
    titleHelp: "Valgfri overskrift som vises over porteføljetabellen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    showIsin: "Vis ISIN",
    showIsinHelp: "Vis ISIN-kode for hvert produkt",
    showWeights: "Vis produktvekter",
    showWeightsHelp: "Vis prosentvis allokering for hvert produkt",
    showAmount: "Vis beløp",
    showAmountHelp: "Vis investeringsbeløp for hvert produkt",
    showUnits: "Vis andeler",
    showUnitsHelp: "Vis antall andeler for andelsbestilte produkter",
  },
} as const;
